import React from 'react';
import { Link } from 'react-router-dom';
import { srcsetImage } from '../helpers';

class WorkThumbnail extends React.Component {
	constructor(props) {
		super(props);
		this.checkerThumbnails = this.checkerThumbnails.bind(this);

		// initial state
		this.state = {
			displayedThumbnail: ''
		}
	}

	componentDidMount() {
		if(this.props.checkerThumbs === true) {
			this.checkerThumbnails();
		} else {
			this.setState({displayedThumbnail: this.props.details.thumbnail});
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if((prevProps.columns !== this.props.columns || prevProps.orderOfFour !== this.props.orderOfFour) && this.props.checkerThumbs === true) {
			this.checkerThumbnails();
		}
	}

	// If type is logo we need to checkerboard the thumbnail page
	checkerThumbnails() {
		// For two column layouts we need to determind what order of four the
		// image comes in. The first and fourth image are normal, 
		// the second and third used the reverse thumbnail.
		if(this.props.columns === 2) {

			if(this.props.orderOfFour === 1 || this.props.orderOfFour === 0) {
				this.setState({displayedThumbnail: this.props.details.thumbnailReverse});
			} else {
				this.setState({displayedThumbnail: this.props.details.thumbnail});
			}
		}
		// For 1 or 3 columns every even image in the order is set to reverse
		else {
			let isEven = this.props.orderOfFour % 2 === 0 ? true : false;

			if(isEven) {
				this.setState({displayedThumbnail: this.props.details.thumbnail});
			} else {
				this.setState({displayedThumbnail: this.props.details.thumbnailReverse});
			}
		}
	}

	render() {

		let projectInformationClasses = ['workThumbnail--projectInformation'];

		if(this.props.details.subtitle) {
			var theSubtitleJSX = <span className="workThumbnail--subtitle">{this.props.details.subtitle}</span>;
			projectInformationClasses.push('hasSubtitle');
		}

		if(this.props.details.type === 'featured-news') {
			projectInformationClasses.push('type--featured-news');
		}

		if(this.props.details.thumbnailPadding) {
			var thumbnailInlineStyle = {'paddingBottom': `${this.props.details.thumbnailPadding}%`};
		}

		if(this.props.details.linkTo) {
			var thumbnailLink = this.props.details.linkTo;
		} else {
			thumbnailLink = `/work/project/${this.props.details.slug}`;
		}

		return (
			<div className="workThumbnail">
				<Link to={thumbnailLink}>
					<div className="workThumbnail--thumbnail" style={thumbnailInlineStyle}>
						{srcsetImage(this.state.displayedThumbnail, null, 4)}
					</div>
					<span className={projectInformationClasses.join(" ")}>
						<span className="workThumbnail--title">{this.props.details.title}</span>{theSubtitleJSX}
					</span>
				</Link>
			</div>
		)
	}
}

export default WorkThumbnail;


/** WEBPACK FOOTER **
 ** ./src/components/WorkThumbnail.js
 **/